export default (authors) => {
    //return last author for a post
    if (!authors || authors.length <=  1) return null; //must be more than 1 author passed in
    const lastIndex = authors.length - 1;
    return authors[lastIndex];
}